import DatePicker from '@storeblocks/datepicker';
import { WrapLgMarginBottom } from 'App/global-style';
import { add, startOfDay } from 'date-fns';
import { useFormikContext } from 'formik';
import { getMaxNumberOfDaysAllowedForProduct } from 'Forms/CancelFormV2/cancelForm.helpers';
import React from 'react';
import { getAppText } from 'Utils/text';
import { isDefined } from 'Utils/type.utils';
import { CancelFormValuesWithFutureCancelDate } from '../../cancelForm.types';

interface FutureCancelDateProps {
  disabled: boolean;
}

export const FutureCancelDate = ({
  disabled,
}: FutureCancelDateProps): React.ReactElement => {
  const { values, setFieldValue, errors } =
    useFormikContext<CancelFormValuesWithFutureCancelDate>();

  const maxDays = getMaxNumberOfDaysAllowedForProduct();
  const endDate = add(startOfDay(new Date()), {
    days: maxDays,
  });

  return (
    <WrapLgMarginBottom>
      <DatePicker
        id="futureCancelDate"
        name="futureCancelDate"
        label={getAppText('cancel.futureCancelDate.label')}
        hint={getAppText('cancel.futureCancelDate.hint', {
          insert: { numberOfDays: maxDays },
        })}
        onChange={(_, value) => setFieldValue('futureCancelDate', value)}
        disabled={disabled}
        locale="no"
        min={add(startOfDay(new Date()), { days: 1 })}
        max={endDate}
        error={isDefined(values.futureCancelDate) && errors.futureCancelDate}
        value={values.futureCancelDate}
      />
    </WrapLgMarginBottom>
  );
};
